import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Placeholder from '@tiptap/extension-placeholder';
import Link from '@tiptap/extension-link';
import Highlight from '@tiptap/extension-highlight';
import TextAlign from '@tiptap/extension-text-align';
import TaskList from '@tiptap/extension-task-list';
import TaskItem from '@tiptap/extension-task-item';
import Image from '@tiptap/extension-image';
import Typography from '@tiptap/extension-typography';
import Subscript from '@tiptap/extension-subscript';
import Superscript from '@tiptap/extension-superscript';
import EditorToolbar from './EditorToolbar';
import './simple-editor.css';

const extensions = [
  StarterKit.configure({
    heading: { levels: [1, 2, 3] },
  }),
  Placeholder.configure({ placeholder: "Type '/' for commands, or start typing..." }),
  Link.configure({ openOnClick: false, autolink: true }),
  Highlight.configure({ multicolor: true }),
  TextAlign.configure({ types: ['heading', 'paragraph'] }),
  TaskList,
  TaskItem.configure({ nested: true }),
  Image,
  Typography,
  Subscript,
  Superscript,
];

export default function SimpleEditor({ content, onChange }) {
  const editor = useEditor({
    immediatelyRender: false,
    extensions,
    content,
    editorProps: {
      attributes: { class: 'simple-editor' },
    },
    onUpdate: ({ editor }) => {
      onChange(editor.getJSON());
    },
  });

  if (!editor) {
    return <div className="simple-editor__loading">Loading editor...</div>;
  }

  return (
    <div className="simple-editor__wrap">
      <div className="simple-editor__toolbar">
        <EditorToolbar editor={editor} />
      </div>
      <EditorContent editor={editor} className="simple-editor__content" />
    </div>
  );
}
